import React from 'react'
import { Col, Input, Label, Row } from 'reactstrap';
import { MunicipalitySelect } from "@dhn/components/molecules/municipality-select";
import { ProvinceSelect } from "@dhn/components/molecules/province-select";
import { SectorSelect } from "@dhn/components/molecules/sector-select";
import ReactFormat from "react-number-format";

export default function BranchSubTab({ state, onChange, params }) {

  return (
    <div className='animated fadeIn'>
      <Row form className='mt-2'>
        <Col>
          <Label>Sucursal:</Label>
          <Input value={state?.name || ""} onChange={({ target: { value } }) => onChange("name", value, 'branchSelected')} placeholder='Escribir Sucursal' />
        </Col>
        <Col>
          <Label>Contacto:</Label>
          <Input value={state?.contact || ""} onChange={({ target: { value } }) => onChange("contact", value, 'branchSelected')} placeholder='Escribir Contacto' />
        </Col>
      </Row>
      <Row form className='my-4'>
        <Col>
          <Label>Teléfono:</Label>
          <ReactFormat
            placeholder='Digitar Teléfono'
            className="bg-white"
            customInput={Input}
            format="(###) ###-####"
            displayType="input"
            onChange={({ target: { value } }) => onChange("phone", value, 'branchSelected')}
            value={state?.phone || ""}
          />
        </Col>
        <Col>
          <Label>Correo Electrónico:</Label>
          <Input value={state?.email || ""} onChange={({ target: { value } }) => onChange("email", value?.trim(), 'branchSelected')} placeholder='Escribir Correo Electrónico' />
        </Col>
      </Row>
      <Row form className='my-4'>
        <Col>
          <Label>Dirección:</Label>
          <Input value={state?.address || ""} onChange={({ target: { value } }) => onChange("address", value, 'branchSelected')} placeholder='Escribir Dirección' />
        </Col>
      </Row>
      <Row form className='mt-4'>
        <Col sm="4">
          <ProvinceSelect
            item={{ id: state?.provinceId }}
            onSelect={(item) => onChange("provinceId", parseInt(item.id), 'branchSelected')
            }
          />
        </Col>
        <Col sm="4">
          <MunicipalitySelect
            item={{ id: state?.municipalityId || "" }}
            provinceId={state?.provinceId || ""}
            onSelect={(item) => onChange("municipalityId", parseInt(item.id), 'branchSelected')}
          />
        </Col>
        <Col sm="4">
          <SectorSelect
            item={{ id: parseInt(state?.sectorId) || "" }}
            municipalityId={state?.municipalityId || ""}
            onSelect={(item) => onChange("sectorId", parseInt(item.id), 'branchSelected')}
          />
        </Col>
      </Row>
    </div>
  )
}
